<template>
  <el-dialog title="修改名称" :visible.sync="show">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-position="left" label-width="110px">
      <!-- {{this.$store.getters.tokenuserName || '4444'}} -->
      <el-form-item label="单位名称" prop="titleName">
        <el-input v-model="form.titleName" placeholder="请输入单位名称" style="width: 200px" />
      </el-form-item>
      <el-form-item label="数据大屏标题" prop="datavName">
        <el-input v-model="form.datavName" placeholder="请输入数据大屏标题" style="width: 200px" />
      </el-form-item>
      <el-form-item label="用户名称" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入名称" style="width: 200px" />
      </el-form-item>
      <el-form-item label="自定义头像">
        <div class="avatar-uploaders">
          <el-upload class="avatar-uploader" action="" :http-request="upLoad" :show-file-list="false"
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </div>
        <div>
          <span>上传头像图片只能是 JPG 或 PNG 格式!</span>
          <br>
          <span>上传头像图片大小不能超过 2MB!</span>
          <span />
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="logoAffirm('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import {mapMutation} from 'vuex'

import qs from 'qs'
export default {
  data() {
    return {
      formLabelWidth: '240',
      show: false,
      form: {
        datavName: '',
        // id:'',
        titleName: '',
        userName: ''
      },
      imageUrl: '',
      rules: {
        titleName: [
          { required: true, message: '请输入单位名称' },
          {
            min: 3,
            max: 8,
            message: '长度在 3 到 8 个字符'
            //
          }
        ],
        datavName: [
          { required: true, message: '大屏展示名称' },
          {
            min: 3,
            max: 11,
            message: '长度在 3 到 11 个字符'
          }
        ],
        userName: [
          { required: true, message: '请输入用户名称' },
          {
            min: 1,
            max: 22,
            message: '长度在 1 到 22 个字符'
          }
        ],
        imageUrlData: ''
      }
    }
  },
  // created() {
  //   // vue的生命周期 创建前
  //   // this.userName =  userNamer).userName

  //   this.$EventBus.$on('section', msg => {
  //     this.show = msg
  //     if (this.show) {
  //       this.form.titleName = this.$store.getters.form
  //         ? this.$store.getters.form.TITLE_NAME
  //         : '励拓新安智能消防'
  //       this.form.datavName = this.$store.getters.form
  //         ? this.$store.getters.form.DATAV_NAME
  //         : '励拓新安大数据可视化中心'
  //       this.form.userName = this.$store.getters.form
  //         ? userNamer || this.$store.getters.tokenuserName
  //         : ''
  //       this.imageUrl = this.$store.getters.protoImg
  //         ? this.$store.getters.protoImg
  //         : ''
  //     }
  //   })
  //   const userNamer = JSON.parse(window.sessionStorage.getItem('userNamer'))
  //     .userName
  // },
  created() {
    // 1. 先取值（修复原有空值报错）
    const userStorage = JSON.parse(window.sessionStorage.getItem('userNamer'));
    const userNamer = userStorage?.userName || '';

    // 2. 先解绑再绑定（防止重复监听）
    this.$EventBus.$off('section');
    this.$EventBus.$on('section', msg => {
      this.show = msg;
      if (this.show) {
        const storeForm = this.$store.getters.form || {};
        this.form.titleName = storeForm.TITLE_NAME || '励拓新安智能消防';
        this.form.datavName = storeForm.DATAV_NAME || '励拓新安大数据可视化中心';
        this.form.userName = storeForm ? (userNamer || this.$store.getters.tokenuserName || '') : '';
        this.imageUrl = this.$store.getters.protoImg || '';
      }
    });
  },
  // 必须解绑事件，避免内存泄漏和重复执行
  destroyed() {
    this.$EventBus.$off('section');
  },
  methods: {
    resetForm(formName) {
      this.show = false
      this.$refs[formName].resetFields()
    },
    // 点击上传用户信息
    logoAffirm(ruleForm) {
      // if (this.$store.getters.protoImg === '') return this.$message.error("您当前没有设置头像,请上传头像后再进行操作")
      if (
        this.form.datavName === '' ||
        this.form.titleName === '' ||
        this.form.userName === ''
      ) {
        this.$confirm('当前操作会让某个标题为空, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // this.$message({
            //   type: 'success',
            //   message: '已修改成功!'
            // })
            this.uploadingData(this.form, ruleForm)
            this.show = false
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消修改'
            })
          })

        return
      }
      this.show = false

      // 上传用户所有信息
      this.uploadingData(this.form, ruleForm)

      // 8c40c3a7-4abd-4baf-9088-58cd4104b6b8
    },
    // 上传信息到后台
    async uploadingData(forms, ruleForm) {
      const token = this.$store.getters.token
      const res = await this.$axios.post(
        // '/api/user/info',
        '/api/user/updateUserInfo',
        qs.stringify(forms),
        {
          headers: { Authorization: token }
        }
      )
      if (res.data.code !== 200) {
        return this.$message.error('更改失败!请刷新重试')
      }
      this.$store.commit('logoTitle/userName', forms.userName)
      sessionStorage.setItem('userNamer', JSON.stringify(forms))
      this.$message({
        message: '已完成替换',
        type: 'success'
      })
      this.$store.dispatch('logoTitle/userInfo') // 触发userInfo
      // 获取图片信息
      this.$store.dispatch('logoTitle/userImage') //
      this.$refs[ruleForm].resetFields()
    },

    async upLoad(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      const token = this.$store.getters.token
      const res = await this.$axios.post(
        // '/api/file/upload?type=image',
        '/api/user/upload?type=image',
        formData,
        {
          headers: { Authorization: token }
        }
      )
      if (res.data.code !== 200) {
        return this.$message.error('上传失败!')
      }
      this.$message({
        message: '上传成功',
        type: 'success'
      })
      this.form.imagePath = res.data.data
    },

    delss() {
      this.show = !this.show
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isPG = isJPG || isPNG
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isPG && isLt2M
    }
  }
}
</script>

<style lang="scss" scoped>
// 图片上传

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploaders {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  margin-right: 20px;
}

.avatar-uploaders:hover {
  border-color: #409eff;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
  // background-color: aqua;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

// 图片上传</style>
